var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "my-stays" },
    [
      _c("simple-list", {
        ref: "list",
        attrs: {
          "server-items": _vm.items,
          query: "status",
          "undefined-value": _vm.tc("reservations.allMyStaysLabel"),
          variant: "my-stays-list",
        },
        scopedSlots: _vm._u([
          {
            key: "filter",
            fn: function () {
              return [
                _vm.stays.length > 0
                  ? _c(
                      "div",
                      {
                        staticClass: "filter",
                        attrs: { "data-component": "booking-room-filters" },
                      },
                      [
                        _c("accessible-tabs", [
                          _c(
                            "div",
                            {
                              ref: "myStays",
                              staticClass: "filter-items",
                              class: [{ "no-upcoming": !_vm.isUpcomingExist }],
                              attrs: { role: "tablist" },
                            },
                            [
                              _c(
                                "button",
                                {
                                  staticClass: "filter-item tab-group-button",
                                  class: [{ active: !_vm.status }, "all"],
                                  attrs: {
                                    id: "stay-filter-all",
                                    href: "",
                                    role: "tab",
                                    "aria-selected": !_vm.status,
                                    tabindex: !_vm.status ? "0" : "-1",
                                  },
                                  on: {
                                    click: function ($event) {
                                      $event.preventDefault()
                                      return _vm.filterByStatus()
                                    },
                                    keydown: [
                                      function ($event) {
                                        if (
                                          !$event.type.indexOf("key") &&
                                          _vm._k(
                                            $event.keyCode,
                                            "right",
                                            39,
                                            $event.key,
                                            ["Right", "ArrowRight"]
                                          )
                                        ) {
                                          return null
                                        }
                                        if (
                                          "button" in $event &&
                                          $event.button !== 2
                                        ) {
                                          return null
                                        }
                                        $event.preventDefault()
                                        return _vm.filterByStatus(
                                          _vm.statusItems[0]
                                        )
                                      },
                                      function ($event) {
                                        if (
                                          !$event.type.indexOf("key") &&
                                          _vm._k(
                                            $event.keyCode,
                                            "left",
                                            37,
                                            $event.key,
                                            ["Left", "ArrowLeft"]
                                          )
                                        ) {
                                          return null
                                        }
                                        if (
                                          "button" in $event &&
                                          $event.button !== 0
                                        ) {
                                          return null
                                        }
                                        $event.preventDefault()
                                        return _vm.filterByStatus(
                                          _vm.statusItems[
                                            _vm.statusItems.length - 1
                                          ]
                                        )
                                      },
                                    ],
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(
                                        _vm.tc("reservations.allMyStaysLabel")
                                      ) +
                                      "\n            "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _vm._l(_vm.statusItems, function (item, i) {
                                return _c(
                                  "button",
                                  {
                                    key: item.code,
                                    staticClass: "filter-item tab-group-button",
                                    class: [
                                      { active: _vm.status === item },
                                      item.cardType,
                                    ],
                                    attrs: {
                                      id: "stay-filter-" + i,
                                      href: "",
                                      role: "tab",
                                      "aria-controls": _vm.status
                                        ? _vm.status.code
                                        : "",
                                      "aria-selected": item === _vm.status,
                                      tabindex:
                                        item === _vm.status ? "0" : "-1",
                                    },
                                    on: {
                                      click: function ($event) {
                                        $event.preventDefault()
                                        return _vm.filterByStatus(item)
                                      },
                                      keydown: [
                                        function ($event) {
                                          if (
                                            !$event.type.indexOf("key") &&
                                            _vm._k(
                                              $event.keyCode,
                                              "right",
                                              39,
                                              $event.key,
                                              ["Right", "ArrowRight"]
                                            )
                                          ) {
                                            return null
                                          }
                                          if (
                                            "button" in $event &&
                                            $event.button !== 2
                                          ) {
                                            return null
                                          }
                                          $event.preventDefault()
                                          return _vm.filterByStatus(
                                            i === _vm.statusItems.length - 1
                                              ? null
                                              : _vm.statusItems[0]
                                          )
                                        },
                                        function ($event) {
                                          if (
                                            !$event.type.indexOf("key") &&
                                            _vm._k(
                                              $event.keyCode,
                                              "left",
                                              37,
                                              $event.key,
                                              ["Left", "ArrowLeft"]
                                            )
                                          ) {
                                            return null
                                          }
                                          if (
                                            "button" in $event &&
                                            $event.button !== 0
                                          ) {
                                            return null
                                          }
                                          $event.preventDefault()
                                          return _vm.filterByStatus(
                                            i === 0
                                              ? null
                                              : _vm.statusItems[
                                                  _vm.statusItems.length - 1
                                                ]
                                          )
                                        },
                                      ],
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(item.label) +
                                        "\n            "
                                    ),
                                  ]
                                )
                              }),
                            ],
                            2
                          ),
                        ]),
                      ],
                      1
                    )
                  : _vm._e(),
              ]
            },
            proxy: true,
          },
          {
            key: "rendered-list",
            fn: function (ref) {
              var filteredItems = ref.items
              return [
                _c(
                  "ul",
                  _vm._l(filteredItems, function (item) {
                    return _c("flipping-card", {
                      key: item.id,
                      attrs: {
                        card: item,
                        "status-data": _vm.getStatusDataByCode(item.status),
                        "modify-page": _vm.modifyPage,
                      },
                    })
                  }),
                  1
                ),
              ]
            },
          },
          {
            key: "pagination",
            fn: function (ref) {
              var pagination = ref.pagination
              var defaultLimit = ref.defaultLimit
              var allLoaded = ref.allLoaded
              return [
                _c("pagination", {
                  attrs: {
                    "total-pages": _vm.totalPages,
                    "current-page": _vm.currentPage,
                  },
                  on: {
                    "prev-page": _vm.prevPage,
                    "next-page": _vm.nextPage,
                    "goto-page": _vm.gotoPage,
                  },
                }),
              ]
            },
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }